import React from "react";
import { useTranslation } from "react-i18next";
import { opportunityStyle } from "../lib/format";

export default function OpportunityBadge({ index, score, size = "md" }) {
  const { t } = useTranslation();
  const styles = opportunityStyle(index);
  const label = t(`opportunity.${index}`);

  const sizeCls =
    size === "sm"
      ? "px-2 py-0.5 text-[10px] gap-1"
      : "px-2.5 py-1 text-xs gap-1.5";

  return (
    <span
      data-testid={`opportunity-badge-${index}`}
      className={`inline-flex items-center rounded-full font-semibold border ${styles.pill} ${sizeCls}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${styles.dot}`} />
      <span className="tracking-tight">{label}</span>
      {typeof score === "number" && (
        <span className="ml-1 tabular-nums text-slate-500 font-medium">
          {score.toFixed(0)}
        </span>
      )}
    </span>
  );
}
